import { render, staticRenderFns } from "./lebcForm.vue?vue&type=template&id=5ccabc6b&scoped=true"
import script from "./lebcForm.vue?vue&type=script&lang=js"
export * from "./lebcForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ccabc6b",
  null
  
)

export default component.exports